// this is an awesome typescript hack to move errors from runtime to compilation time
// it can be used in e.g. in default clauses of switch statements to make sure we covered all cases of e.g. enum or type
// when we add new option (new enum value, new type value), the compiler will guide us where our attention is needed
export const exhaustiveCheck = (param: never): never => {
  throw new Error(`should not reach here with ${param}`);
};
